// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.meeting-round{width:5px;height:5px;border-radius:50%}`, "",{"version":3,"sources":["webpack://./src/styles/components/meetingRound.scss"],"names":[],"mappings":"AAAA,eACE,SAAA,CACA,UAAA,CACA,iBAAA","sourcesContent":[".meeting-round {\n  width: 5px;\n  height: 5px;\n  border-radius: 50%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
